module.exports = __webpack_public_path__ + "img/江苏大学logo-300x284.7c53a592.jpg";